import { Component, OnInit } from '@angular/core';
import { AnnouncementService } from '../services/announcement.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-announcement-view',
  templateUrl: './announcement-view.component.html',
  styleUrls: ['./announcement-view.component.scss']
})
export class AnnouncementViewComponent implements OnInit {
  tickerItems: string[];
  showAnnouncement: boolean;
  redirectURL: string;

  constructor(private announcementService: AnnouncementService, private toastrService: ToastrService) { }

  ngOnInit(): void {
    this.showAnnouncement = false;
    this.redirectURL = "";

    this.announcementService.getAnnouncements().subscribe(({ data }) => {
      if (!data) return;

      const { content, display, redirect_to } = data;
      this.tickerItems = [`${content}`,];
      this.showAnnouncement = display;
      this.redirectURL = redirect_to;
    }, (error) => {
      this.toastrService.error(error.message);
    })
  }

  isClickable(): boolean {
    return this.showAnnouncement && this.redirectURL && this.redirectURL.length > 0;
  }

  onClickRedirect() {
    // window.open(this.redirectURL, "_blank");
    if (this.redirectURL && this.redirectURL.length) {
      window.location.href = this.redirectURL;
    }
  }
}
